"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var size_enum_1 = __importDefault(require("../../shared/enums/size.enum"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
var eventHelper_1 = __importDefault(require("../../shared/utilities/eventHelper"));
var fa_icon_1 = __importDefault(require("../fa-icon"));
function Indicator(_a) {
    var icon = _a.icon, size = _a.size, className = _a.className, callback = _a.callback, otherProps = __rest(_a, ["icon", "size", "className", "callback"]);
    var actionCallback = callback !== null && callback !== void 0 ? callback : null;
    return (react_1.default.createElement("div", __assign({}, otherProps, (0, eventHelper_1.default)(actionCallback), { className: "mpng-ux-indicator" }),
        react_1.default.createElement(fa_icon_1.default, { icon: icon, squared: true, size: size || size_enum_1.default.MEDIUM, className: (0, classMap_1.default)("mpng-ux-indicator-icon", className) })));
}
exports.default = Indicator;
